import { createPlatform } from './Factory';
import { PlatformInterface } from './interfaces';

let _platform: PlatformInterface | undefined;

export function platform(): PlatformInterface {
    if (_platform === undefined) {
        _platform = createPlatform();
    }

    return _platform;
}
